import styled from 'styled-components'
import videoButtonPlayHover from '../../../../static/steam-img/video-button-play-hover.svg'
import videoButtonPlayNormal from '../../../../static/steam-img/video-button-play-normal.svg'
import videoButtonPlayPressed from '../../../../static/steam-img/video-button-play-pressed.svg'
import { Gradient, GradientOverlayColor } from '../../../constants/contentfulStyle.constant'

export const PlayButton = styled.div`
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    z-index: 2;
    position: absolute;
    margin: 0 auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
    opacity: 0.8;
    transition: all 0.2s ease-in-out;
    background: url(${videoButtonPlayNormal}) center / 100% no-repeat;
  }
`

export const VideoImageContainer = styled.div<{
  $outerPage: string
}>`
  ${({ theme, $outerPage }) => {
    if ($outerPage && $outerPage === 'aboutRPA') {
      return `
        background: ${theme.webMktNewPalette.deepBlue[70]};
      `
    }
  }}
`

export const VideoImage = styled.div<{
  $outerPage: string
  $imageOverlay: string
}>`
  position: relative;
  z-index: 1;

  img {
    width: 100%;
  }

  ${({ $outerPage, theme }) => {
    if ($outerPage === 'aboutRPA') {
      return `
        width: 792px;
        height: 479px;
        overflow: hidden;
        margin: 0 auto;

        ${theme.breakpoints.down('md')} {
          width: 796px;
          height: 485px;
        }

        ${theme.breakpoints.down('sm')} {
          width: 536px;
          height: 387px;
        }

        ${theme.breakpoints.down('xs')} {
          width: 328px;
          height: 236px;
        }

        .VideoPlayer__Image-File {
          width: 100%;
          top: 50%;
          transform: translateY(-50%) translateX(-50%);
          position: absolute;
          left: 50%;
        }
      `
    }
  }}

  &:hover {
    &:after {
      background: ${({ theme }) => theme.webMktNewPalette.alphaBlack[40]};
    }

    ${PlayButton}:after {
      opacity: 1;
      background: url(${videoButtonPlayHover}) center / 100% no-repeat;
    }
  }

  &:active {
    ${PlayButton}:after {
      opacity: 1;
      background: url(${videoButtonPlayPressed}) center / 100% no-repeat;
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    transition: all 0.5s ease-in-out;
    background: ${({ theme }) => theme.webMktNewPalette.alphaBlack[20]};
    cursor: pointer;
  }

  ${({ $imageOverlay, theme }) => {
    if ($imageOverlay === Gradient.TEAL) {
      let gradient = GradientOverlayColor(Gradient.TEAL)

      return `
        &:after {
          background: ${gradient}
        }

        &:hover {
          &:after {
            opacity: 0.5;
            background: ${gradient}
          }
        }
      `
    }
  }}
`

export const VideoOverlay = styled.div`
  background-image: none;
  background-color: ${({ theme }) => theme.webMktNewPalette.alphaBlack[60]};
`

export const HTMLVideo = styled.video`
  &#videoSpotlight-html-video {
    pointer-events: auto;
  }

  &#tencentVideoPlayer {
    pointer-events: auto;
    width: 100%;
  }
`
